import { AppEntity, ContactInformationSchema, PostalAddressSchema } from '@app/icare/db/schema/common'
import { entityId } from '@pkg/db/schema'
import { z } from 'zod'

export const CareServiceId = entityId('careService')

export type CareServiceIdType = typeof CareServiceId.Type

export const CareServiceSchema = AppEntity.extend({
  id: CareServiceId.schema,
  name: z.coerce.string().min(1).max(255).default(''),
  comment: z.coerce.string().nullish(),
  remarks: z.coerce.string().nullish(),
  serviceArea: z.string().max(255).nullish(),
  address: PostalAddressSchema.nullish(),
  contact: ContactInformationSchema.nullish(),
})

export type CareService = z.infer<typeof CareServiceSchema>
